<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-task" data-toggle="modal" data-target="#exampleModal">Add</button> -->
  
            <div class="personal-details">
                <div class="row">
                  <div class="col-md-9 col-lg-9">
                    <div class="map-container">
                      <div class="map-frame">
                        <div id="map">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3" style="padding-left: 0;">
                    <input type="text" placeholder="search" [(ngModel)]="search" class="form-control">
                    <div class="customerList">
                      <!-- <p (click)="onChoseLocation()" >All</p> -->
                      <p *ngFor="let list of RouteData | filter:search;let i = index " (click)="singleLocation(list.routeId)">{{list.routeName}}</p>
                    </div>
                  </div>
                </div>
            
            </div>
  
        </div>
    </div>
  </div>